// extracted by mini-css-extract-plugin
module.exports = {"menu":"Select_menu__21y9a","fadeIn":"Select_fadeIn__szibJ","menu__close":"Select_menu__close__2JX4Q","fadeOut":"Select_fadeOut__1jsoR"};